if (window.BSS_BCP_V2?.r4q?.logics?.length) {

  document.addEventListener('bcpR4q:openForm', () => {
    setTimeout(() => {
      const wrapper = document.querySelector('bcp-r4q-form-wrapper');
      const formMainRoot = wrapper?.shadowRoot?.querySelector('bcp-r4q-form-main')?.shadowRoot;
      if (!formMainRoot) return;

      const productList = formMainRoot.querySelector('.product-list');
      if (!productList) return;

      let row = formMainRoot.getElementById('bcp-custom-r4q-total-row');
      if (!row) {
        row = document.createElement('div');
        row.id = 'bcp-custom-r4q-total-row';
        row.style.display = 'flex';
        row.style.justifyContent = 'space-between';
        row.style.fontWeight = '700';
        row.style.fontSize = '16px';
        row.style.padding = '12px 0';
        row.style.borderTop = '1px solid #e1e1e1';
        row.style.marginTop = '8px';

        const label = document.createElement('span');
        label.textContent = 'Total';
        const value = document.createElement('span');
        value.className = 'bcp-custom-r4q-total-value';

        row.appendChild(label);
        row.appendChild(value);
        productList.insertAdjacentElement('afterend', row);
      }
      const totalValueEl = row.querySelector('.bcp-custom-r4q-total-value');

      function formatMoney(cents, format) {
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        format = format || Shopify?.money_format || '${{amount}}';

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = Number.isNaN(precision) ? 2 : precision;
          thousands = thousands === undefined ? ',' : thousands;
          decimal = decimal === undefined ? '.' : decimal;

          if (Number.isNaN(number)) return 0;

          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          const centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
        }

        let value = '';
        switch (format.match(placeholderRegex)?.[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ', '');
            break;
          case 'amount_with_period_and_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;
          default:
            value = formatWithDelimiters(cents, 2);
            break;
        }

        return format.replace(placeholderRegex, value);
      }

      function parseFormattedPrice(text) {
        const cleaned = text.replace(/[^\d,.-]/g, '');
        const lastSepIndex = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
        if (lastSepIndex === -1) return Number(cleaned);

        const integerPart = cleaned.slice(0, lastSepIndex).replace(/[,.]/g, '');
        const decimalPart = cleaned.slice(lastSepIndex + 1);
        return Number(integerPart + '.' + decimalPart);
      }

      const observedLineItems = new WeakSet();

      function recalcTotal() {
        const lineItems = productList.querySelectorAll('bcp-r4q-line-item');

        let total = 0;
        let hasPendingPrice = false;
        lineItems.forEach(function (lineItem) {
          if (!observedLineItems.has(lineItem) && lineItem.shadowRoot) {
            const lineItemObserver = new MutationObserver(recalcTotal);
            lineItemObserver.observe(lineItem.shadowRoot, { subtree: true, childList: true, characterData: true });
            observedLineItems.add(lineItem);
          }

          const quotedTotalEl = lineItem.shadowRoot?.querySelector('.total-price .quoted-total');
          if (!quotedTotalEl) {
            hasPendingPrice = true;
            return;
          }

          const price = parseFormattedPrice(quotedTotalEl.textContent);
          if (Number.isNaN(price)) {
            hasPendingPrice = true;
            return;
          }
          total += price;
        });

        totalValueEl.textContent =
          formatMoney(Math.round(total * 100)) + (hasPendingPrice ? ' (calculating...)' : '');
      }

      recalcTotal();
      new MutationObserver(recalcTotal).observe(productList, { childList: true, subtree: true });
    }, 500);
  });
}
